<template>
  <div class="brandIncreasePage">
    <div class="banner">
      <img src="../../assets/images/banner3.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon3">
        <i class="iconfont icon-pinpaizichanpingtai"></i>
      </div>
      <div class="breadcrumb_item">物流&订单管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">出库管理</div>
    </div>

    <div class="main_content">
      <div class="data_list" v-if="dataList.length > 0">
        <div
          class="data_item"
          v-for="item in dataList"
          :key="item.id"
          @click="handleDetail(item.id)"
        >
          <div class="row_one mb">
            <p>物流ID：{{ item.wsid }}</p>
            <p>订单ID：{{ item.orderid }}</p>
          </div>
          <div class="row_one mb">
            <p>商品内容：</p>
            <div class="shop_con">
              <p>商品名称：{{ item.cmname }}</p>
              <!-- <p>商品ID：{{ item.id }}</p> -->
              <p>SKU：{{ item.sku }}</p>
              <p>{{item.attr}}</p>
              <!-- <div v-for="(label, labelIndex) in item.attr" :key="labelIndex">
                <p>
                  <span>{{ label | formatAttr }}</span>
                </p>
              </div> -->
              <p>商品所属企业：{{ item.qyguidstr }}</p>
              <p>配货所需数量：{{ item.cmnum }}</p>
            </div>
          </div>
          <div class="row_one mb">
            <div class="warehouse_item flex-rowl">
              <p class="left">库源信息：</p>
              <p v-html="item.msg"></p>
            </div>
            <p>商品类型：{{item.ismain ? '主商品' : '配件'}}</p>
            <p>操作时间：{{ item.createdate | formatDate }}</p>
          </div>
        </div>
      </div>

      <div class="noData" v-else>
        <p>尚未添加配货信息</p>
      </div>
    </div>

    <div class="fixd_button_btm" v-if="isShowTabbar">
      <!-- <div class="return-fixd"> -->
      <div class="item" @click="handleReturn">返回</div>
      <!-- <div class="item" @click="handleDetail(0)">新增配货</div> -->
    </div>
    <!-- <Tabbar v-if="isShowTabbar"></Tabbar> -->
  </div>
</template>

<script>
import { getMenuAuthTwo, encryptstringadd, encryptstringview } from "../../api/api";
// import Tabbar from "../../components/Tabbar.vue";
import { getLogisticsDisList } from "../../api/shop";
import { mapState } from "vuex";
export default {
  name: "outboundDistributionList",
  // components: {
  //   Tabbar,
  // },
  data() {
    return {
      isShowTabbar: true,
      menuItem: "", // 权限菜单
      roleId: "", // 用户角色ID
      operationAuth: "", // 操作权限
      buttonAuth: "", // 按钮权限

      keyword: "",
      qyid: 0,
      qyguid: 0,

      dataList: [],
      params: {
        wsid: "",
        pageindex: 1,
        pagesize: 20,
      },
      listTotal: 0,
      loading: false, // 是否正在加载中
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
    formatAttr(date) {
      if (date.indexOf("；") != -1) {
        let splitArr = date.split("；");
        let str1 = "属性标签：" + splitArr[0];
        let str2 = "属性标签值：" + splitArr[1];
        return str1 + "；" + str2;
      } else {
        let str = "属性标签：" + date;
        return str;
      }
      // let splitArr = date.indexOf('；') != -1 ? date.split('；') : date
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.qyid = USERINFO.qy.id ? USERINFO.qy.id : "";

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  mounted() {
   
    window.addEventListener("scroll", this.handleSrcoll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleSrcoll);
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { wsid } = JSON.parse(res.jsondata);
        this.params.wsid = wsid;
         this.getLogisticsDisList(); // 初始化加载数据
      } else {
        this.$router.back();
      }
    },

    // 获取菜单栏权限
    getMenuAuthTwo() {
      let menuItem = this.$store.state.menuItem;
      getMenuAuthTwo(menuItem.parentid).then((res) => {
        res
          .filter((item) => {
            return item.id == menuItem.id;
          })
          .map((item) => {
            // 操作权限
            if (item.dorange) {
              this.operationList = item.dorange.split(",");
            }
          });
      });
    },

    getLogisticsDisList() {
      let { params } = this;
      getLogisticsDisList(params).then((res) => {
        res.list.forEach((v) => {
          v.msg = v.msg != "" ? v.msg.replace(/\|/g, "<br/>") : "";
          v.attr = v.attr != "" ? JSON.parse(v.attr) : "";
        });
        this.dataList = res.list;
        this.listTotal = res.total;
      });
    },
    // 滚动事件
    handleSrcoll() {
      const windowHeight = window.innerHeight; // 窗口可见高度
      const documentHeight = document.documentElement.scrollHeight; // 文档高度
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop; // 滚动条距离顶部的距离

      if (
        scrollTop + windowHeight >= documentHeight &&
        !this.loading &&
        this.dataList.length < this.listTotal
      ) {
        this.params.pageindex += 1;
        this.getLogisticsDisList();
      }
    },

    handleReturn() {
      history.back();
    },
    handleDetail(id) {
      // this.$router.push(
      //   `/outboundIndex/outboundDistribution/${id}/${this.params.wsid}`
      // );
      this.encryptstringadd('outboundDistribution', {id, wsid: this.params.wsid})
    },
    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
    // 获取焦点
    handleFocus() {
      this.isShowTabbar = false;
    },
    // 失去焦点
    handleBlur() {
      this.isShowTabbar = true;
    },
  },
};
</script>
<style lang="less" scoped>
.brandIncreasePage {
  padding-bottom: 400px;
  .data_item {
    width: 650px;
    border: 1px solid #d2d2d2;
    margin: 0 auto 30px;
    padding: 40px;
    font-size: 20px;
    color: #3c3c3c;
    box-sizing: border-box;
    .row_one {
      font-size: 22px;
      align-items: flex-start;
      &.mb {
        margin-bottom: 30px;
      }
      p {
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
        &.left {
          white-space: nowrap;
        }
      }
      .warehouse_item {
        align-items: flex-start;
        margin-bottom: 20px;
        p {
          line-height: 30px;
        }
      }
      .shop_con {
        p {
          margin-bottom: 10px;
        }
      }
    }
    .row_shop_list {
      margin: 27px 0 55px;
      color: #3c3c3c;
      .shop_item {
        margin-bottom: 30px;
      }
      .shop_name_num {
        margin-bottom: 22px;
        .shop_name_num_item {
          align-items: flex-start;
          margin-bottom: 4px;
        }
        p {
          font-size: 20px;
          &.label {
            white-space: nowrap;
          }
        }
      }
      .shop_price {
        font-size: 18px;
        .txt {
          margin-top: 10px;
        }
      }
    }
    .row_two {
      margin-bottom: 40px;
      p {
        margin-bottom: 6px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .row_three {
      margin-bottom: 36px;
      font-size: 22px;
    }
    .row_four {
      margin-bottom: 50px;
      font-size: 22px;
      span {
        margin-right: 17px;
      }
      .txt {
        margin-bottom: 10px;
        p {
          &:last-child {
            font-size: 30px;
          }
        }
        span {
          font-size: 20px;
        }
      }
      .txt1 {
        margin-bottom: 30px;
      }
    }
    .order_status {
      font-size: 22px;
      .txt {
        margin-bottom: 10px;
      }
      .red {
        color: #ee0032;
      }
    }
  }
  .noData p {
    text-align: center;
    font-size: 28px;
    color: #aaaaaa;
    padding: 150px 0;
  }
}
</style>